module.exports = __webpack_public_path__ + "static/assets/7597269cc47cd288d56fc20bf1075091.png";